const environment = process.env.REACT_APP_ENVIRONMENT || "production";

const getConfiguration = () => {
  switch (environment) {
    case "development":
      return {
        apiUrl: "https://api-staging.investhinks.com/api",
        basename: "",
        revolut_env: "prod",
      };
    default:
    case "staging":
      return {
        apiUrl: "https://api-staging.investhinks.com/api",
        basename: "",
        revolut_env: "prod",
      };
  }
};

export default getConfiguration();
